module.exports = __webpack_public_path__ + "img/facilities_07.6c316795.jpg";